<template>
  <section data-aos="fade-right" data-aos-offset="300">
    <div class="section-header">
      <div class="grid-container flex-container">
        <div class="header-text-wrap">
          <h3 v-html="title"></h3>
          <p v-if="subtext" v-text="subtext"></p>
        </div>
      </div>
    </div>
    <div class="section-content" data-aos="fade-left" data-aos-offset="300">
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  name: 'VisualDataSection',
  props: {
    title: String,
    subtext: String
  },
  mounted () {
    $('.fin-header-shape-wrap').filter(':even').each(function () {
      $(this).addClass('odd');
    });
  }
};
</script>
